import { render, staticRenderFns } from "./ClassManage.vue?vue&type=template&id=76290065&scoped=true&"
import script from "./ClassManage.vue?vue&type=script&lang=js&"
export * from "./ClassManage.vue?vue&type=script&lang=js&"
import style0 from "./ClassManage.vue?vue&type=style&index=0&id=76290065&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76290065",
  null
  
)

export default component.exports